const Title = () => {
  return <div className='title'>Best Sellers in Books</div>;
};
export default Title;
